module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lte-box box",
    class: [_vm.boxType, {
      'collapsed-box': _vm.collapsed
    }]
  }, [_c('div', {
    staticClass: "box-header",
    class: {
      'with-border': _vm.showHeaderBorder
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._t("box-title", [(!!_vm.icon) ? _c('i', {
    class: _vm.icon
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.header) + "\n      ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_vm._t("box-tools")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._t("default")], 2), _vm._v(" "), (!!_vm.$slots['box-footer']) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_vm._t("box-footer")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98fd9942","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/box/box.vue
// module id = 7
// module chunks = 0